document.addEventListener("DOMContentLoaded", () => {
    initSwiper();
    initAccordion();
});
function initSwiper(){
    const sliderOption = {
        centeredSlides : true,
        disableOnInteraction: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: ".swiper-slide-num", // ページネーションのクラス名を指定
            type: "fraction", // ページネーションのtypeを指定
        },
        slidesPerView: '1',
        breakpoints: {
            600: {
                slidesPerView: 1
            }
        }
    }

    const mainSlider1 = new Swiper ('.slider-main1',sliderOption);
}


function initAccordion(){
    var btns = document.getElementsByClassName('open');
    var btn = Array.prototype.slice.call(btns);
    btn.forEach(function(value){
        value.addEventListener('click',function(){

            var btnClasss = value.classList;
            var btnClass = Array.prototype.slice.call(btnClasss);

            var target = value.nextElementSibling;
            if(btnClass.indexOf('is-active') != -1){
                value.classList.remove('is-active');
                target.style.display = 'none';

            }else{
                value.classList.add('is-active');
                target.style.display = 'block';

            }
        });
    });
}